/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

// Decides whether the `buy-now-location-exclusion` LaunchDarkly flag should hide
// the Buy Now button for the given reservation location. The flag value is a JSON
// object: { "enabled": boolean, "location_ids": string[] }.
// - If the flag cannot be read (missing/malformed), hide the button.
// - If `enabled` is false, do not apply any location gating.
// - If `enabled` is true, hide the button when the location is on the list.
export function isBuyNowLocationExcluded(exclusionFlag, locationId) {
    if (!exclusionFlag || typeof exclusionFlag !== 'object') {
        return true;
    }
    if (!exclusionFlag.enabled) {
        return false;
    }
    if (!Array.isArray(exclusionFlag.location_ids)) {
        return true;
    }
    return exclusionFlag.location_ids.includes(locationId);
}
